/* eslint-disable react-hooks/rules-of-hooks */
import { createSlice } from "@reduxjs/toolkit";
import { login } from "../actions/auth";

const initialState = {
  token: "",
  loading: false,
  errorMessage: null,
  errorType: null,
};

const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {},
  extraReducers: {
    // login
    [login.pending]: (state, action) => {
      state.loading = true;
      state.errorMessage = null;
      state.errorType = null;
    },
    [login.fulfilled]: (state, action) => {
      state.loading = false;
      state.token = action.payload.token;
    },
    [login.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload.message;
      state.errorType = action.payload.msgType;
    },
  },
});

export const responseAuth = (state) => state.authentication;

export default authSlice.reducer;
